module.exports = __webpack_public_path__ + "static/img/feelgrid.2223658.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/feelgrid.svg
// module id = h33O
// module chunks = 13